module.exports = __webpack_public_path__ + "static/media/zadania-powtorkowe-do-egzaminu-osmoklasisty-matematyka-8-1.1668e252.jpg";